export default "__VITE_ASSET__DVQFXovA__"